// All CSS as a template literal — injected into Shadow DOM <style>
export const embedStyles = `
/* Reset inside shadow DOM */
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:host {
  display: block;
  font-family: 'DM Sans', system-ui, -apple-system, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #292524;
  -webkit-font-smoothing: antialiased;
}

.dte-container {
  max-width: 480px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e7e5e4;
  overflow: hidden;
}

/* Header */
.dte-header {
  padding: 20px 20px 16px;
  border-bottom: 1px solid #f5f5f4;
}

.dte-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #0d9488;
  margin-bottom: 8px;
}

.dte-title {
  font-family: 'Sora', system-ui, -apple-system, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #1c1917;
  margin-bottom: 4px;
}

.dte-description {
  font-size: 13px;
  color: #78716c;
  margin-top: 8px;
}

.dte-location {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #57534e;
  margin-top: 8px;
}

/* Status banners */
.dte-banner {
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
}

.dte-banner-closed {
  background: #fee2e2;
  color: #991b1b;
}

.dte-banner-voted {
  background: #dcfce7;
  color: #166534;
}

/* Vote grid */
.dte-grid {
  padding: 16px 20px;
}

.dte-date-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Sora', system-ui, -apple-system, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #44403c;
  padding: 10px 0 6px;
  border-bottom: 1px solid #f5f5f4;
  margin-bottom: 4px;
}

.dte-date-header:first-child {
  padding-top: 0;
}

/* Slot/option row */
.dte-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #fafaf9;
}

.dte-row:last-child {
  border-bottom: none;
}

/* Vote button */
.dte-vote-btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 2px solid #e7e5e4;
  background: #ffffff;
  color: #a8a29e;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  line-height: 1;
}

.dte-vote-btn:hover {
  border-color: #0d9488;
  color: #0d9488;
}

.dte-vote-btn-yes {
  background: #22c55e;
  border-color: #22c55e;
  color: #ffffff;
}

.dte-vote-btn-yes:hover {
  background: #16a34a;
  border-color: #16a34a;
  color: #ffffff;
}

.dte-vote-btn-maybe {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #ffffff;
}

.dte-vote-btn-maybe:hover {
  background: #d97706;
  border-color: #d97706;
  color: #ffffff;
}

.dte-vote-btn-no {
  background: #ef4444;
  border-color: #ef4444;
  color: #ffffff;
}

.dte-vote-btn-no:hover {
  background: #dc2626;
  border-color: #dc2626;
  color: #ffffff;
}

.dte-vote-btn:disabled {
  cursor: default;
  opacity: 0.6;
}

.dte-vote-btn:disabled:hover {
  border-color: inherit;
  color: inherit;
}

/* Slot/option label */
.dte-label {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #292524;
}

.dte-label-time {
  font-weight: 500;
}

.dte-label-allday {
  font-style: italic;
  color: #57534e;
}

/* Result bar */
.dte-result {
  flex-shrink: 0;
  width: 80px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dte-bar-track {
  height: 6px;
  background: #f5f5f4;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
}

.dte-bar-yes {
  background: #22c55e;
  height: 100%;
  transition: width 0.3s ease;
}

.dte-bar-maybe {
  background: #f59e0b;
  height: 100%;
  transition: width 0.3s ease;
}

.dte-bar-no {
  background: #ef4444;
  height: 100%;
  transition: width 0.3s ease;
}

.dte-count {
  font-size: 11px;
  color: #a8a29e;
  text-align: right;
}

/* Voter badges */
.dte-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 2px 0 6px 46px;
}

.dte-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 999px;
}

.dte-badge-yes {
  background: #dcfce7;
  color: #166534;
}

.dte-badge-maybe {
  background: #fef3c7;
  color: #92400e;
}

.dte-badge-no {
  background: #fee2e2;
  color: #991b1b;
}

/* Form */
.dte-form {
  padding: 16px 20px;
  border-top: 1px solid #e7e5e4;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dte-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dte-input-label {
  font-size: 12px;
  font-weight: 500;
  color: #57534e;
}

.dte-input {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #e7e5e4;
  border-radius: 10px;
  font-size: 13px;
  font-family: inherit;
  color: #292524;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease;
}

.dte-input:focus {
  border-color: #0d9488;
}

.dte-input::placeholder {
  color: #a8a29e;
}

.dte-submit {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 10px;
  background: #0d9488;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease;
}

.dte-submit:hover {
  background: #0f766e;
}

.dte-submit:disabled {
  background: #a8a29e;
  cursor: not-allowed;
}

/* Error message */
.dte-error {
  padding: 8px 12px;
  background: #fee2e2;
  color: #991b1b;
  border-radius: 8px;
  font-size: 12px;
  text-align: center;
}

/* Footer / branding */
.dte-footer {
  padding: 10px 20px;
  border-top: 1px solid #f5f5f4;
  text-align: center;
}

.dte-branding {
  font-size: 11px;
  color: #a8a29e;
  text-decoration: none;
}

.dte-branding:hover {
  color: #0d9488;
}

/* Loading */
.dte-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 12px;
}

.dte-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e7e5e4;
  border-top-color: #0d9488;
  border-radius: 50%;
  animation: dte-spin 0.6s linear infinite;
}

@keyframes dte-spin {
  to { transform: rotate(360deg); }
}

.dte-loading-text {
  font-size: 13px;
  color: #a8a29e;
}

/* Error state (full widget) */
.dte-error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  gap: 8px;
  text-align: center;
}

.dte-error-icon {
  font-size: 24px;
}

.dte-error-title {
  font-size: 14px;
  font-weight: 600;
  color: #44403c;
}

.dte-error-message {
  font-size: 12px;
  color: #78716c;
}
`;
